import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const asyncSelectEndAdornment = css`
  bottom: 1.2rem;
`;

export const asyncSelectClasses = {
  endAdornment: cn(asyncSelectEndAdornment, 'absolute'),
};
